const NOTIFICATION_TEMPLATE_KEY = "notification_template_records_v1";

const DEMO_TEMPLATES = [
  {
    id: "email-template-001",
    channel: "email",
    deliveryType: "email",
    templateName: "Booking Confirmation",
    module: "customer",
    target: "Booking",
    subject: "Your {{service_name}} booking is confirmed",
    body:
      "Hi {{customer_name}},\n\nYour booking {{booking_id}} is confirmed for {{scheduled_date}}. Our team will reach out before arrival if needed.\n\nThanks,\nTeam Seeb",
    secondaryField: "Track your booking in the Seeb app",
    variables: ["customer_name", "service_name", "booking_id", "scheduled_date"],
    status: "active",
    notes: "Used after payment success and slot confirmation.",
    createdAt: "2026-03-20T10:00:00+05:30",
    updatedAt: "2026-03-22T09:30:00+05:30",
    isDemo: true,
  },
  {
    id: "email-template-002",
    channel: "email",
    deliveryType: "email",
    templateName: "Festival Offer Launch",
    module: "partner",
    target: "Offer",
    subject: "A new seasonal campaign is live for your area",
    body:
      "Hello {{partner_name}},\n\nWe have launched a new seasonal campaign for {{service_name}}. Please review availability and keep your dashboard updated for fresh leads.\n\nSupport: {{support_number}}",
    secondaryField: "Boost visibility by keeping slots open this week",
    variables: ["partner_name", "service_name", "support_number"],
    status: "draft",
    notes: "Internal partner awareness email before promo blast.",
    createdAt: "2026-03-18T13:00:00+05:30",
    updatedAt: "2026-03-21T16:10:00+05:30",
    isDemo: true,
  },
  {
    id: "sms-template-001",
    channel: "sms-phone",
    deliveryType: "sms",
    templateName: "Tomorrow Reminder",
    module: "customer",
    target: "Reminder",
    subject: "Service Reminder",
    body:
      "Hi {{customer_name}}, your {{service_name}} booking {{booking_id}} is scheduled on {{scheduled_date}}. Need help? Call {{support_number}}.",
    secondaryField: "SEEBIN",
    variables: ["customer_name", "service_name", "booking_id", "scheduled_date", "support_number"],
    status: "active",
    notes: "Keep message under one SMS block when possible.",
    createdAt: "2026-03-19T11:45:00+05:30",
    updatedAt: "2026-03-22T08:20:00+05:30",
    isDemo: true,
  },
  {
    id: "phone-template-001",
    channel: "sms-phone",
    deliveryType: "phone",
    templateName: "Partner Escalation Call Script",
    module: "partner",
    target: "Escalation",
    subject: "Missed Slot Follow-up",
    body:
      "Hello {{partner_name}}, this is Seeb support calling about booking {{booking_id}} scheduled for {{scheduled_date}}. Please confirm your revised arrival time and the reason for delay.",
    secondaryField: "Support Desk",
    variables: ["partner_name", "booking_id", "scheduled_date"],
    status: "active",
    notes: "Phone script for urgent operational follow-up.",
    createdAt: "2026-03-17T15:00:00+05:30",
    updatedAt: "2026-03-23T12:05:00+05:30",
    isDemo: true,
  },
];

const safeParse = (value) => {
  try {
    return JSON.parse(value);
  } catch (_error) {
    return [];
  }
};

const getSeededTemplates = () => DEMO_TEMPLATES.map((item) => ({ ...item }));

const getAllTemplates = () => {
  const raw = localStorage.getItem(NOTIFICATION_TEMPLATE_KEY);

  if (raw === null) {
    const seededTemplates = getSeededTemplates();
    localStorage.setItem(NOTIFICATION_TEMPLATE_KEY, JSON.stringify(seededTemplates));
    return seededTemplates;
  }

  const parsedTemplates = safeParse(raw);
  if (!Array.isArray(parsedTemplates) || parsedTemplates.length === 0) {
    const seededTemplates = getSeededTemplates();
    localStorage.setItem(NOTIFICATION_TEMPLATE_KEY, JSON.stringify(seededTemplates));
    return seededTemplates;
  }

  return parsedTemplates;
};

export const getNotificationTemplates = (channel) =>
  getAllTemplates()
    .filter((item) => !channel || item?.channel === channel)
    .sort((a, b) => new Date(b?.updatedAt || 0).getTime() - new Date(a?.updatedAt || 0).getTime());

export const upsertNotificationTemplate = (template) => {
  const existingTemplates = getAllTemplates();
  const now = new Date().toISOString();

  const nextTemplate = {
    ...template,
    id: template?.id || `template-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    createdAt: template?.createdAt || now,
    updatedAt: now,
    isDemo: false,
  };

  const hasExistingRecord = existingTemplates.some((item) => String(item?.id) === String(nextTemplate.id));
  const nextTemplates = hasExistingRecord
    ? existingTemplates.map((item) => (String(item?.id) === String(nextTemplate.id) ? { ...item, ...nextTemplate } : item))
    : [nextTemplate, ...existingTemplates];

  localStorage.setItem(NOTIFICATION_TEMPLATE_KEY, JSON.stringify(nextTemplates));
  return nextTemplate;
};

export const deleteNotificationTemplate = (templateId) => {
  const nextTemplates = getAllTemplates().filter((item) => String(item?.id) !== String(templateId));
  localStorage.setItem(NOTIFICATION_TEMPLATE_KEY, JSON.stringify(nextTemplates));
  return nextTemplates;
};
